import { render, staticRenderFns } from "./aboutUsAndRegistration.vue?vue&type=template&id=6b05f274&"
import script from "./aboutUsAndRegistration.vue?vue&type=script&lang=js&"
export * from "./aboutUsAndRegistration.vue?vue&type=script&lang=js&"
import style0 from "./aboutUsAndRegistration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports